
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function splitSigAndPub(
  combined: Uint8Array,
  sigLength = 64
): { signature: Uint8Array; publicKey: Uint8Array } {
  return {
    signature: combined.slice(0, sigLength),
    publicKey: combined.slice(sigLength),
  };
}